'use client';

import { CSSProperties } from 'react';

type BadgeProps = {
    name: string;
    style?: CSSProperties;
};

function Badge(props: BadgeProps) {
    const { name, style } = props;

    return (
        <div
            className="flex h-26 flex-none rounded-4 px-8 py-2 text-body-bold-12 items-center whitespace-nowrap bg-[var(--surface-color)] text-[var(--on-surface-color)]"
            style={style}>
            {name}
        </div>
    );
}

export default Badge;
